/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-02-22 09:44:59
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-24 10:55:30
 */

import { API_PREFIX } from './constant'
import { ContentType, MultiPartFormData, Request } from './request'

export interface ReservationChannelListPrams {
  current: number
  size: number
  name: string
  status: string
}

// 列表
export function reservationChannelList(
  params: ReservationChannelListPrams
): Request {
  return {
    url: `${API_PREFIX}/blade-appointment/appointmentchannel/page`,
    method: 'GET',
    params,
  }
}


export interface ReservationChannelEditPrams {
  status?: any
  tenantId?: any
  comment?:any
}

// 保存
export function reservationChannelEditSubmit(
  body: ReservationChannelEditPrams
): Request {
  return {
    url: `${API_PREFIX}/blade-appointment/appointmentchannel/save`,
    method: 'POST',
    body,
  }
}

export interface ReservationChannelUploadPrams {
  id?: string
}

// 保存
export function reservationChannelUpload(
  params: ReservationChannelUploadPrams
): Request {
  return {
    url: `${API_PREFIX}/blade-appointment/appointmentchannel/updateStatus`,
    method: 'GET',
    params,
  }
}
